/**
 * 动画库
 * @module
 */

/**
 * @export
 * @type {{box: {show, fill, psh, hide, resize, mask, pos, alpha, twalpha, size, twsize}, page: {top, width, height, theight, twidth}}}
 */
var tiny = {
  box: (function () {
    var p,
      m,
      b,
      close,
      ic,
      iu,
      iw,
      ih,
      ia,
      f = 0
    return {
      /**
       * 图片展示
       * @param c {string} 显示的AJAX或HTML内容
       * @param u {number} 是否为AJAX 0或1
       * @param w {number} 宽度，0代表自动
       * @param h {number} 高度 ，0代表自动
       * @param a {number} 是否设置为隐藏 0或1
       * @param s {object} 包含图片url，图片要显示的宽度w和高度h
       * @param t {number} 是否自动隐藏的时间
       */
      show: function (c, u, w, h, a, s, t) {
        if (!f) {
          p = document.createElement("div")
          p.id = "preview-box"
          m = document.createElement("div")
          m.id = "preview-box-mask"
          b = document.createElement("div")
          b.id = "preview-box-content"
          close = document.createElement("div")
          close.id = "preview-box-close"
          close.className = "previewclose"
          document.body.appendChild(m)
          document.body.appendChild(p)
          document.body.appendChild(close)
          p.appendChild(b)
          m.onclick = tiny.box.hide
          close.onclick = tiny.box.hide
          window.onresize = tiny.box.resize
          f = 1
        }
        if (!a && !u) {
          p.style.backgroundImage = "none"
          b.innerHTML = c
        } else {
          b.style.display = "none"
          p.style.position = "absolute"
          p.style.backgroundImage = "url(" + s.url + ")"
          p.style.backgroundSize = s.w + "px " + s.h + "px"
          p.style.width = p.style.height = "100px"
          p.style.zIndex = "1060"
        }
        this.mask()
        ic = c
        iu = u
        iw = w
        ih = h
        ia = a
        this.alpha(m, 1, 60, 3, close)
        if (t) {
          setTimeout(function () {
            tiny.box.hide()
          }, 1000 * t)
        }
        document.body.style.overflow = "hidden"
      },

      fill: function (c, u, w, h, a) {
        if (u) {
          p.style.backgroundImage = ""
          var x = window.XMLHttpRequest ? new XMLHttpRequest() : new window.ActiveXObject("Microsoft.XMLHTTP")
          x.onreadystatechange = function () {
            if (x.readyState == 4 && x.status == 200) {
              tiny.box.psh(x.responseText, w, h, a)
            }
          }
          x.open("GET", c, 1)
          x.send(null)
        } else {
          this.psh(c, w, h, a)
        }
      },
      psh: function (c, w, h, a) {
        if (a) {
          if (!w || !h) {
            var x = p.style.width,
              y = p.style.height
            b.innerHTML = c
            p.style.width = w ? w + "px" : ""
            p.style.height = h ? h + "px" : ""
            b.style.display = ""
            w = parseInt(b.offsetWidth)
            h = parseInt(b.offsetHeight)
            b.style.display = "none"
            p.style.width = x
            p.style.height = y
          } else {
            b.innerHTML = c
          }
          this.size(p, w, h, 4)
        } else {
          p.style.backgroundImage = "none"
        }
      },
      hide: function () {
        tiny.box.alpha(p, -1, 0, 5, close)
        document.body.style.overflow = ""
      },
      resize: function () {
        tiny.box.pos()
        tiny.box.mask()
      },
      mask: function () {
        m.style.height = tiny.page.theight() + "px"
        m.style.width = ""
        m.style.width = tiny.page.twidth() + "px"
      },
      pos: function () {
        var t = tiny.page.height() / 2 - p.offsetHeight / 2
        t = t < 10 ? 10 : t
        p.style.top = t + tiny.page.top() + "px"
        p.style.left = tiny.page.width() / 2 - p.offsetWidth / 2 + "px"
      },
      alpha: function (e, d, a, s, close) {
        clearInterval(e.ai)
        if (d == 1) {
          e.style.opacity = 0
          e.style.filter = "alpha(opacity=0)"
          e.style.display = "block"
          if (close) {
            close.style.display = "block"
            close.style.opacity = 0
            close.style.filter = "alpha(opacity=0)"
          }
          this.pos()
        }
        e.ai = setInterval(function () {
          tiny.box.twalpha(e, a, d, s, close)
        }, 5)
      },
      twalpha: function (e, a, d, s, close) {
        var o = Math.round(e.style.opacity * 100)
        if (o == a) {
          clearInterval(e.ai)
          if (d == -1) {
            e.style.display = "none"
            e.style.width = "auto"
            e.style.height = "auto"

            if (close) {
              close.style.display = "none"
            }

            e == p ? tiny.box.alpha(m, -1, 0, 3, close) : (b.innerHTML = p.style.backgroundImage = "")
          } else {
            e == m ? this.alpha(p, 1, 100, 5, close) : tiny.box.fill(ic, iu, iw, ih, ia)
          }
        } else {
          var n = o + Math.ceil(Math.abs(a - o) / s) * d
          e.style.opacity = n / 100
          e.style.filter = "alpha(opacity=" + n + ")"
          if (close && a == 100) {
            close.style.opacity = n / 100
            close.style.filter = "alpha(opacity=" + n + ")"
          }
        }
      },
      size: function (e, w, h, s) {
        e = typeof e == "object" ? e : document.getElementById(e)
        clearInterval(e.si)
        var ow = e.offsetWidth,
          oh = e.offsetHeight,
          wo = ow - parseInt(e.style.width),
          ho = oh - parseInt(e.style.height)
        var wd = ow - wo > w ? -1 : 1,
          hd = oh - ho > h ? -1 : 1
        e.si = setInterval(function () {
          tiny.box.twsize(e, w, wo, wd, h, ho, hd, s)
        }, 5)
      },
      twsize: function (e, w, wo, wd, h, ho, hd, s) {
        var ow = e.offsetWidth - wo,
          oh = e.offsetHeight - ho
        if (ow == w && oh == h) {
          clearInterval(e.si)
          p.style.backgroundImage = "none"
          b.style.display = "block"

          if (close) {
            close.style.display = "block"
          }
        } else {
          e.style.opacity = ow / w
          if (ow != w) {
            e.style.width = ow + Math.ceil(Math.abs(w - ow) / s) * wd + "px"
          }
          if (oh != h) {
            e.style.height = oh + Math.ceil(Math.abs(h - oh) / s) * hd + "px"
          }
          this.pos()
        }
      },
    }
  })(),

  page: (function () {
    return {
      top: function () {
        return document.body.scrollTop || document.documentElement.scrollTop
      },
      width: function () {
        return self.innerWidth || document.documentElement.clientWidth
      },
      height: function () {
        return self.innerHeight || document.documentElement.clientHeight
      },
      theight: function () {
        var d = document,
          b = d.body,
          e = d.documentElement
        return Math.max(Math.max(b.scrollHeight, e.scrollHeight), Math.max(b.clientHeight, e.clientHeight))
      },
      twidth: function () {
        var d = document,
          b = d.body,
          e = d.documentElement
        return Math.max(Math.max(b.scrollWidth, e.scrollWidth), Math.max(b.clientWidth, e.clientWidth))
      },
    }
  })(),
}

export default tiny
